import { useEffect, useState } from 'react';
import { DEFAULT_DEBOUNCE_DELAY_MS } from '@/constants/common';

function useDebouncedValue<T>(value: T, delay: number = DEFAULT_DEBOUNCE_DELAY_MS): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(timeoutId);
  }, [value, delay]);

  return debouncedValue;
}

export default useDebouncedValue;
